import { render, staticRenderFns } from "./modelAnimation2.vue?vue&type=template&id=421129c6&scoped=true&"
import script from "./modelAnimation2.vue?vue&type=script&lang=js&"
export * from "./modelAnimation2.vue?vue&type=script&lang=js&"
import style0 from "./modelAnimation2.vue?vue&type=style&index=0&id=421129c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421129c6",
  null
  
)

export default component.exports